import script from "./XRQuit.vue?vue&type=script&lang=ts&setup=true"
export * from "./XRQuit.vue?vue&type=script&lang=ts&setup=true"

import "./XRQuit.vue?vue&type=style&index=0&id=53f3d028&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53f3d028"]])

export default __exports__